type ContactLike = {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  related_user?: {
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
    phone?: string | null;
  } | null;
  contact?: {
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
    phone?: string | null;
  } | null;
};

const getNameParts = (contact: ContactLike) => {
  const primary = contact.related_user ?? contact.contact ?? contact;

  const first = primary?.first_name?.trim() ?? "";
  const last = primary?.last_name?.trim() ?? "";
  const email = primary?.email?.trim() ?? contact.email?.trim() ?? "";
  const fallback = email || "Contact";

  const name = [first, last].filter(Boolean).join(" ").trim();
  return name || fallback;
};

export const getContactDisplayName = (contact: ContactLike) =>
  getNameParts(contact);

export const CONTACT_NOTIFICATION_MESSAGES = {
  DELETED: (name: string) => `${name} has been removed from your contacts.`,
};

